<style lang="scss" scoped>
  .dalink-page-footer {
    background-color: rgba(0, 0, 0, 0.30);
    text-align: center;
    padding: 12px 10px;
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;

    .links-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1em;
    }

    .divider {
      color: rgba(#ffffff, .9);
      line-height: 16px;

      &.hide-md {
        @include media(max, md) {
          display: none;
        }
      }
    }

    .links {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1em;

      .link {
        color: white;
        line-height: 16px;
        cursor: pointer;
        text-decoration: none;
        white-space: nowrap;
      }
    }

    .copyright {
      margin-top: 12px;
      color: #ffffff;
      line-height: normal;
    }

    .qr-code-modal {
      .qr-code-modal-content {
        padding-bottom: 30px;
      }
    }
  }
</style>

<template>
  <footer class="dalink-page-footer">
    <div class="links-wrapper">
      <div class="links">
        <div class="link" @click="qrModalOpened = true">Смотреть на телефоне</div>
        <div class="divider">·</div>
        <a target="_blank" href="https://www.donationalerts.com/legal" class="link">Правовые документы</a>
      </div>
      <div class="divider hide-md">·</div>
      <div class="links">
        <a target="_blank" href="https://www.donationalerts.com/help" class="link">Поддержка</a>
        <div class="divider">·</div>
        <a target="_blank" href="https://www.donationalerts.com/privacy-policy" class="link">Политика конфиденциальности</a>
      </div>
    </div>
    <div class="copyright">{{ copyright }}</div>
    <modal v-model="qrModalOpened" class="qr-code-modal">
      <template #title>
        QR-код страницы
      </template>
      <template #body-content>
        <div class="qr-code-modal-content">
          <qr-code-display :url="userData.gatewayUrl"/>
        </div>
      </template>
    </modal>
  </footer>
</template>

<script setup>
import { computed, ref } from 'vue'
import QrCodeDisplay from '@components/Dalink/QrCodeDisplay.vue'
import { useDalinkPublicStore } from '@store/dalinkPublic'
import { storeToRefs } from 'pinia'

const dalinkPublicStore = useDalinkPublicStore()

const {
  userData,
} = storeToRefs(dalinkPublicStore)

const copyright = computed(() => '© 2025 Zaya Solutions Limited. All rights reserved. All trademarks are the property of their respective owners')

const qrModalOpened = ref(false)

</script>

